import { z } from "zod";
import { emailField, messageField } from "@core/schemas/fields";

/**
 * Support ticket schema fields
 */
export const supportSchemaFields = {
  email: emailField,
  message: messageField,
};

/**
 * Support ticket form schema
 */
export const baseSupportSchema = z.object(supportSchemaFields);

export type SupportFormData = z.infer<typeof baseSupportSchema>;
